import React from 'react';
import IgCommentGuardSlideoutBannerNormalSrc from './IGCommentGuardSlideoutBanner_normal.png';
import IgCommentGuardSlideoutBannerWhiteSrc from './IGCommentGuardSlideoutBanner_white.png';

export const IGCommentGuardSlideoutBanner = ({
  textColor,
}: {
  textColor: 'white' | 'normal';
}) => {
  return textColor === 'white' ? (
    <img src={IgCommentGuardSlideoutBannerWhiteSrc} />
  ) : (
    <img src={IgCommentGuardSlideoutBannerNormalSrc} />
  );
};
